import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { EnforcementListComponent } from './enforcement-list/enforcement-list.component'

export const enforcementRoutes: Route[] = [
  {
    path: 'enforcements',
    component: EnforcementListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'enforcements/:id/edit',
    redirectTo: 'enforcements/:id',
    pathMatch: 'full'
  },
  {
    path: 'enforcements/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Enforcement',
        nameSingular: 'Enforcement',
        namePlural: 'Enforcements',
        path: 'enforcements',
        slug: 'taxonomies/enforcements',
        title: 'Enforcements'
      }),
      permission: 'readTaxonomies'
    }
  }
]
